import React from "react";
import { Button } from "@mui/material";

const AppButton = ({
  label,
  variant = "contained",
  fullWidth = false,
  onClick,
  sx = {},
}) => {
  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      onClick={onClick}
      sx={{
        textTransform: "none",
        borderRadius: 2,
        ...sx,
      }}
    >
      {label}
    </Button>
  );
};

export default AppButton;
